<iframe 
width="100%" 
height="100%" 
src="https://datastudio.google.com/embed/reporting/8e906b5f-4a5f-46a0-ac14-3d997ef44331/page/VgD" 
frameborder="0" 
style="border:0" 
allowfullscreen
title="DataStudio reporting"></iframe>